<template>
    <div
        v-if="message"
        class="text-center space-y-2 bg-green-100 rounded-xl p-8"
    >
        <span class="size-[42px] inline-block bg-has-success"></span>
        <h2 class="heading h6">
            Success
        </h2>
        <ul>
            <li v-html="message"></li>
        </ul>
    </div>
</template>

<script setup>
    const props = defineProps([
        'message',
    ]);
</script>
